import { useState } from 'react'
import { Button, ButtonGroup } from 'react-bootstrap'
import ProfileSetting from './ProfileSetting'
import UpdatePassword from './UpdatePassword'
// import RegisterCard from './RegisterCard'

const ProfileSettingScreen = () => {

    const [authType, setAuthType] = useState("profileSetting")

    return (
        <>
            <section className='mt-5'>
                <div className="container py-5">
                    <div className="row justify-content-center">
                        <div className="col-lg-6">
                            <h3 className='text-center fw-bold'>Popgop Referral System</h3>
                            <p className='text-center'>Sign in to manage your referral and earning</p>
                            <div className='p-1 bg-light shadow-sm rounded'>
                                <ButtonGroup className='w-100' aria-label="Basic example">
                                    <Button onClick={() => setAuthType("profileSetting")} className={`${authType === "profileSetting" ? "bg-badge " : "bg-light text-dark"} border-0`}>Profile Setting</Button>
                                    <Button onClick={() => setAuthType("register")} className={`${authType === "register" ? "bg-badge " : "bg-light text-dark"} border-0`}>Password Setting</Button>
                                </ButtonGroup>
                            </div>

                            {authType === "register" ? (
                                <>
                                    <UpdatePassword />
                                </>
                            ) : (
                                <>
                                    <ProfileSetting />
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default ProfileSettingScreen